/**
 * @generated SignedSource<<c97f1978ab66e7dc4fc65d02ee054615>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type UsernameInput = {
  username: string;
};
export type AffiliateUsernameInputQuery$variables = {
  input: UsernameInput;
};
export type AffiliateUsernameInputQuery$data = {
  readonly affiliatePartners: {
    readonly validateUsername: {
      readonly errors: ReadonlyArray<string>;
      readonly valid: boolean;
    };
  };
};
export type AffiliateUsernameInputQuery = {
  response: AffiliateUsernameInputQuery$data;
  variables: AffiliateUsernameInputQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AffiliatePartners",
    "kind": "LinkedField",
    "name": "affiliatePartners",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "Username",
        "kind": "LinkedField",
        "name": "validateUsername",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "valid",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "errors",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AffiliateUsernameInputQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AffiliateUsernameInputQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7b45e2b7d5337db240d3a11f544b48de",
    "id": null,
    "metadata": {},
    "name": "AffiliateUsernameInputQuery",
    "operationKind": "query",
    "text": "query AffiliateUsernameInputQuery(\n  $input: UsernameInput!\n) {\n  affiliatePartners {\n    validateUsername(input: $input) {\n      valid\n      errors\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "aac97c2d90eb0b3523252bc0a4d6d593";

export default node;
